// @ts-ignore
import * as React from 'react';
import { ColorResult } from 'react-color'
import SimplePicker from '../../Misc/_components/SimplePicker';
import { Trans } from 'react-i18next';

export type Props = {
	moduleId?: string
	color?: string
	onColorChange?: (color: ColorResult) => void
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class ModuleRadius extends React.Component<Props> {
	render = () => <>
		<SimplePicker onColorChange={this.props.onColorChange} label={<T>Color</T>} color={this.props.color}/>
	</>
}